import { render } from "./AddedToCartNotification.vue?vue&type=template&id=39ef6e7f"
import script from "./AddedToCartNotification.vue?vue&type=script&lang=js"
export * from "./AddedToCartNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__